export const isIPhone = navigator.userAgent.match(/iPhone/i);

export const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);

export const isWx = /micromessenger/i.test(navigator.userAgent); // 是否微信

export const isComWx = isWx && /wxwork/i.test(navigator.userAgent); // 是否企业微信
